import { makeStyles } from 'tss-react/mui';

const DetailedCaseInfo = makeStyles()((theme) => {
    return {
        value: {
            color: theme.palette.primary.main,
        },
        container: {
            borderRadius: 4,
            padding: 20,
            marginBottom: 10,
        },
    };
});

export default DetailedCaseInfo;
